export const BID_STATUSES = {
  none: { label: "Not bid yet", colour: "#E67E22", badge: "" },
  leading: { label: "Leading bid", colour: "#16A34A", badge: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  placed: { label: "Bid placed", colour: "#7C3AED", badge: "bg-violet-100 text-violet-700 border-violet-200" },
  expired: { label: "Bid expired", colour: "#94A3B8", badge: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function bidStatus(job) {
  const b = job.my_bid;
  if (!b) return "none";
  if (b.is_expired) return "expired";
  return job.lowest_bid != null && b.amount <= job.lowest_bid ? "leading" : "placed";
}
